export function downloadFile(fileName, fileType, fileContent) {
  let type = fileType === 'csv' ? 'text/csv' : 'application/pdf';
  var blob = new Blob([fileContent], { type: type });
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, fileName + '.' + fileType);
  } else {
    var element = document.createElement('a');
    element.href = window.URL.createObjectURL(blob);
    element.download = fileName + '.' + fileType;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}

export default {
  downloadFile,
};
